import React from "react";

const Past = () => {
  return (
    <section className="c-main__block">
      <h3 className="c-main__title">¿Quién era antes?</h3>
      <article className="c-past__container-text">
        <div className="c-past__item">
          <p className="c-main__text c-past__text">
            Mi otro lado, el cual descubrí gracias a mi madre y su vena
            artística, me llevó por un camino apasionante antes de dedicarme
            profesionalmente al desarrollo web. Inspirada por su talento por
            todo lo creativo y su amor por la pintura, heredé el gusto por el
            diseño y la fotografía desde muy joven. Esto me llevó a cursar un
            grado superior de imagen y sonido, donde descubrí mi pasión por el
            montaje de video.
          </p>
          <p className="c-main__text c-past__text">
            Comencé trabajando de montadora, pero pronto me di cuenta de que
            necesitaba expandir mis horizontes. Empecé a hacer trabajos de
            diseño de manera amateur, creando cartas de restaurantes y carteles
            de conciertos. A medida que ganaba experiencia, sentí la necesidad
            de complementar mi trabajo en el montaje de video, y fue entonces
            cuando decidí estudiar motion graphics.
          </p>
        </div>
        <div className="c-past__item">
          <p className="c-main__text c-past__text">
            Aunque estaba satisfecha trabajando como motion grapher y montadora
            de video, sentía que todavía tenía más por explorar. Con mi
            experiencia en fotografía y mi habilidad para encontrar la paleta de
            colores perfecta en cada imagen, me aventuré en el mundo del
            etalonaje de video. Tuve la oportunidad de participar en proyectos
            donde pude combinar las tres cosas: motion graphics, edición de
            video y etalonaje, lo cual fue una experiencia increíble.
          </p>
          <p className="c-main__text c-past__text">
            Sin embargo, la pandemia llegó y me quedé sin trabajos. Durante el
            confinamiento, decidí aprovechar el tiempo estudiando 3D con Cinema
            4D. Pero las circunstancias no eran favorables y los trabajos
            escaseaban, por lo que decidí dar un cambio de rumbo y embarcarme en
            el mundo del desarrollo front-end.
          </p>
        </div>
        <div className="c-past__item">
          <p className="c-main__text c-past__text">
            Así es como se inició este nuevo capítulo en mi vida profesional:
            <strong>✨ el desarrollo web ✨</strong>
          </p>
        </div>
      </article>
    </section>
  );
};

export default Past;
